import React, { useState, useEffect, useCallback } from "react";
import * as api from "../../services/api";
import { Loader2 } from "lucide-react";
import FeedPostCard from "./FeedPostCard";

export default function GroupFeed({ groupId }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPosts = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.getGroupFeed(groupId);
      setPosts(data);
    } catch (err) {
      console.error("Load group feed failed:", err);
    } finally {
      setLoading(false);
    }
  }, [groupId]);

  useEffect(() => {
    loadPosts();
  }, [loadPosts]);

  return (
    <section className="grid min-w-0 gap-2">
      <h2 className="px-0.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">Posts</h2>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        </div>
      ) : posts.length === 0 ? (
        <p className="rounded-xl border border-border bg-card px-4 py-6 text-center text-sm text-muted-foreground">
          No posts yet. Post a workout to this group to get it going.
        </p>
      ) : (
        <div className="space-y-3">
          {posts.map((post) => (
            <FeedPostCard key={post.id} post={post} onUpdate={loadPosts} />
          ))}
        </div>
      )}
    </section>
  );
}
